module.exports = __webpack_public_path__ + "img/143.f18a3587.jpg";